// extracted by mini-css-extract-plugin
export default {"line":"divider_line__GR1wJ"};